(() => {
  const MARKER="SIP_WO_STATUS_LAYOUT_RESTORE_V1";
  const STYLE_ID="sip-wo-status-layout-restore-v1";

  const COLORS={
    OPEN:"#ef4444",
    PROGRESS:"#f59e0b",
    RESOLVED:"#3b82f6",
    CLOSED:"#22c55e"
  };

  function norm(el){
    return String(el?.textContent||"")
      .replace(/\s+/g," ")
      .trim();
  }

  function findCard(){
    const all=[...document.querySelectorAll("body *")];
    const title=all.find(el=>norm(el)==="Work Order Status");
    if(!title)return null;

    let el=title;
    for(let i=0;el&&i<9;i++,el=el.parentElement){
      if(!(el instanceof HTMLElement))continue;
      const t=norm(el).toUpperCase();
      if(
        t.includes("WORK ORDER STATUS") &&
        t.includes("OPEN") &&
        t.includes("PROGRESS") &&
        t.includes("RESOLVED") &&
        t.includes("CLOSED")
      ){
        return el;
      }
    }
    return null;
  }

  function ensureStyle(){
    if(document.getElementById(STYLE_ID))return;

    const s=document.createElement("style");
    s.id=STYLE_ID;
    s.textContent=`
      [data-sip-wo-card-v1="1"] [data-sip-wo-content-v1="1"]{
        display:block !important;
        grid-template-columns:none !important;
        grid-auto-flow:row !important;
      }

      [data-sip-wo-card-v1="1"] [data-sip-wo-chart-v1="1"]{
        margin-left:auto !important;
        margin-right:auto !important;
        margin-bottom:16px !important;
      }

      [data-sip-wo-card-v1="1"] canvas{
        max-width:100% !important;
      }
    `;
    document.head.appendChild(s);
  }

  function forceLegendColors(card){
    const nodes=[...card.querySelectorAll("*")];

    for(const status of Object.keys(COLORS)){
      const row=nodes.find(el=>{
        const t=norm(el).toUpperCase();
        return (
          t===status ||
          t.startsWith(status+" ") ||
          t.includes(" "+status+" ")
        );
      });

      if(!row)continue;

      let container=row;
      for(let i=0;container&&i<3;i++,container=container.parentElement){
        if(!(container instanceof HTMLElement))continue;

        const candidates=[
          ...container.querySelectorAll(
            "span,i,b,em,div"
          )
        ];

        const dot=candidates.find(el=>{
          if(!(el instanceof HTMLElement))return false;
          const r=el.getBoundingClientRect();
          const cs=getComputedStyle(el);
          return (
            r.width>0 &&
            r.height>0 &&
            r.width<=20 &&
            r.height<=20 &&
            (
              cs.borderRadius==="50%" ||
              parseFloat(cs.borderRadius||"0")>=5
            )
          );
        });

        if(dot){
          dot.style.backgroundColor=COLORS[status];
          dot.style.borderColor=COLORS[status];
          break;
        }
      }
    }
  }

  function apply(){
    const card=findCard();
    if(!card)return;

    ensureStyle();
    card.dataset.sipWoCardV1="1";

    const candidates=[...card.querySelectorAll("*")];

    const content=candidates.find(el=>{
      if(!(el instanceof HTMLElement))return false;
      const t=norm(el).toUpperCase();
      return (
        !!el.querySelector("canvas") &&
        t.includes("OPEN") &&
        t.includes("PROGRESS") &&
        t.includes("RESOLVED") &&
        t.includes("CLOSED")
      );
    });

    if(content){
      content.dataset.sipWoContentV1="1";

      const chartHolder=[...content.querySelectorAll("*")].find(el=>{
        if(!(el instanceof HTMLElement))return false;
        return !!el.querySelector("canvas") && el!==content;
      });

      if(chartHolder){
        chartHolder.dataset.sipWoChartV1="1";
      }
    }

    forceLegendColors(card);
    console.log(`[${MARKER}] applied`);
  }

  function start(){
    apply();

    new MutationObserver(()=>{
      setTimeout(apply,60);
    }).observe(document.documentElement,{
      childList:true,
      subtree:true
    });

    [150,500,1200].forEach(ms=>setTimeout(apply,ms));
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",start,{once:true});
  }else{
    start();
  }
})();
